var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7052 13.5288L12.6321 11.7401C12.1365 10.9145 11.8746 9.96883 11.8746 9.00634V7.43945C11.8746 5.46133 10.5546 3.78821 8.74956 3.24883V2.12696C8.74956 1.43758 8.18893 0.876953 7.49955 0.876953C6.81016 0.876953 6.24954 1.43758 6.24954 2.12696V3.24883C4.44456 3.78821 3.12456 5.46133 3.12456 7.43945V9.00634C3.12456 9.96883 2.86267 10.9138 2.36767 11.7395L1.29456 13.5282C1.23643 13.6251 1.23517 13.7451 1.29081 13.8432C1.34644 13.9413 1.44957 14.002 1.56207 14.002H13.4371C13.5496 14.002 13.6533 13.9414 13.7089 13.8439C13.7646 13.7463 13.7627 13.6251 13.7052 13.5288Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53174 14.627C5.88424 15.3632 6.63049 15.877 7.49984 15.877C8.3692 15.877 9.11548 15.3632 9.46798 14.627H5.53174Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.876953)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.7e7b531773ba7d5bd5ccd120aa182c0b.svg";
export { ForwardRef as ReactComponent };